import { CallNow } from "../../../../src/components/layout/ReusableComponents.js";
import * as React from 'react';
export default {
  CallNow,
  React
};